/**
 * @generated SignedSource<<9a29d0e282975ac6df1660fb30185582>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOpinionArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly authorLarge: {
      readonly url: string;
    } | null;
    readonly image: {
      readonly url: string;
    } | null;
    readonly name: string;
  } | null> | null;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly description: {
        readonly json: Schema | null;
      } | null;
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
  readonly " $fragmentType": "headerOpinionArticle";
};
export type headerOpinionArticle$key = {
  readonly " $data"?: headerOpinionArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerOpinionArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerOpinionArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormattedValue",
              "kind": "LinkedField",
              "name": "description",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "type": "AUTHOR_IMAGE"
              }
            }
          ],
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
        },
        {
          "alias": "authorLarge",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "type": "AUTHOR_LARGE"
              }
            }
          ],
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "image(filter:{\"type\":\"AUTHOR_LARGE\"})"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "70ed4b9014289def97899807c18cb32c";

export default node;
